import { render, staticRenderFns } from "./iconChevronRight.vue?vue&type=template&id=4cd28e8f&scoped=true"
var script = {}
import style0 from "./iconChevronRight.vue?vue&type=style&index=0&id=4cd28e8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd28e8f",
  null
  
)

export default component.exports